import { getApiCall, postApiCall, postEndlessListApiCall } from "./tokenService";
import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { InstantMessageChannelItems } from "ui/Scripts/source/models/instantMessage/instantMessageChannelItems";
import { InstantMessageChannelAddUsersSuccess } from "ui/Scripts/source/models/instantMessage/instantMessageChannelAddUsersSuccess";
import { IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { UserListItem } from "../user/userListItem";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { InstantMessageChannelNew } from "ui/Scripts/source/models/instantMessage/instantMessageChannelNew";
import { InstantMessageChannelEdit } from "ui/Scripts/source/models/instantMessage/instantMessageChannelEdit";

export const getInstantMessageChannelNew = (): Promise<InstantMessageChannelNew> => {
    return getApiCall<InstantMessageChannelNew>("api/instantmessagechannel/new", InstantMessageChannelNew);
};

export const getInstantMessageChannelItems = (): Promise<InstantMessageChannelItems> => {
    return getApiCall<InstantMessageChannelItems>("api/instantmessagechannel", InstantMessageChannelItems);
};

export const getInstantMessageChannelEdit = (instantMessageChannelId: string): Promise<InstantMessageChannelEdit> => {
    return getApiCall<InstantMessageChannelEdit>("api/instantmessagechannel/edit?id=" + instantMessageChannelId, InstantMessageChannelEdit);
};

export const saveInstantMessageChannelEdit = (obj: any): Promise<SaveSuccess> => {
    return postApiCall<SaveSuccess>("api/instantmessagechannel/editsave", SaveSuccess, JSON.stringify(obj));
};

export const removeInstantMessageChannel = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessagechannel/remove?id=" + id, ApiSuccess);
};

export const exitInstantMessageChannel = (id: string, companyId: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessagechannel/exit?id=" + id + "&companyId=" + companyId, ApiSuccess);
};

export const instantMessageChannelEditRemoveUsers = (obj: any): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessagechannel/editremoveusers", ApiSuccess, JSON.stringify(obj));
};

export const instantMessageChannelEditAddUsers = (obj: any): Promise<InstantMessageChannelAddUsersSuccess> => {
    return postApiCall<InstantMessageChannelAddUsersSuccess>("api/instantmessagechannel/editaddusers", InstantMessageChannelAddUsersSuccess, JSON.stringify(obj));
};

export const instantMessageChannelEditSetUserType = (obj: any): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessagechannel/editsetusertype", ApiSuccess, JSON.stringify(obj));
};

export const instantMessageChannelUserInvitationHandle = (id: string, channelId: string, approve: boolean): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/instantmessagechannel/invitation?id=" + id + "&channelId=" + channelId + "&approve=" + approve.toString(), ApiSuccess);
};

// #region UserSelect
export const instantMessageChannelGetSelectUserListItems = (channelCompanyId: string, channelId: string, companyId: string, page: number, ignoreUserCodes: string[]): Promise<IEndlessList<UserListItem>> => {
    return postEndlessListApiCall<UserListItem>("api/instantmessagechannel/selectuserslist", UserListItem, JSON.stringify({
        channelCompanyId,
        channelId,
        companyId,
        page,
        ignoreUserCodes
    }));
};
// #endregion UserSelect